module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-stone-path-background-remnants.affc56b6.png";